import {Button} from 'common/button'
import {Modal} from 'common/modal'
import {Text} from 'common/text'
import {THEME_SEMANTICS} from 'common/theme/_semantics'
import { useTranslation } from 'react-i18next'

export const FacebookLayoutGeneralLogoutModal = ({
  onClose,
  onSubmit,
  ...props
}) => {
  const {t} = useTranslation()
  return (
    <Modal
      {...props}
      actions={
        props?.actions
          ? props.actions
          : [
              <Button
                appearance="ghost"
                size="sm"
                style={{minWidth: 110}}
                onClick={onClose}
              >
                {t('general_cancel')}
              </Button>,
              <Button
                size="sm"
                style={{
                  minWidth: 110,
                  marginLeft: 8,
                  background: THEME_SEMANTICS.failed,
                  borderColor: THEME_SEMANTICS.failed,
                }}
                onClick={onSubmit}
              >
                {t('log_out')}
              </Button>,
            ]
      }
      title={props?.title || t('logout_confirmation')}
      width={props?.width || 480}
      onClose={onClose}
    >
      <Text as="p" style={{padding: '8px 0 16px 0'}}>
        {t('confirm_logout_message')}
      </Text>
    </Modal>
  )
}
